import React from "react";
import { Box, Typography, Chip, Grid } from "@mui/material";
import { Image } from "@mui/icons-material";
import { KeyValueRow } from "../../../rcAutoDetails2/tabs/preventivi";

const Generali = ({ item }) => {
  if (!item) return null;

  return (
    <Box p={3}>
      <Grid container spacing={4} alignItems="center">
        {/* Image Section */}
        <Grid item xs={12} display="flex" justifyContent="center">
          {item.image ? (
            <img
              src={`/static/img/companies/${item.image}`}
              alt={item.compagnia}
              style={{
                width: "150px",
                height: "150px",
                objectFit: "contain",
              }}
            />
          ) : (
            <Image
              alt={item.compagnia}
              sx={{
                width: 120,
                height: 120,
                bgcolor: "gray",
              }}
            />
          )}
        </Grid>

        {/* Data Section */}
        <Grid item xs={12}>
          <Box>
            {Object.entries(item.info || {})
              .filter(([_, v]) => v !== "")
              .map(([key, value], id) => (
                <KeyValueRow key={id} isEven={id % 2 === 0}>
                  <Typography
                    variant="body2"
                    color="textPrimary"
                    fontWeight="bold"
                    textAlign="right"
                  >
                    {key}:
                  </Typography>

                  {key === "Guida" ? (
                    <Chip
                      label={value}
                      color={value === "Libera" ? "success" : "warning"}
                      sx={{
                        ...(value === "Libera" && {
                          backgroundColor: "#2e7d32",
                        }),
                        color: "white",
                        height: 20,
                        fontWeight: "bold",
                      }}
                    />
                  ) : (
                    <Typography variant="body2" textAlign="right">
                      {value || "-"}
                    </Typography>
                  )}
                </KeyValueRow>
              ))}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Generali;
